module.exports = __webpack_public_path__ + "img/cmbs-data-0.9bd3f73e.svg";